import { useEffect, useState } from "react";
import { Container, Paper, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Button, Alert, Skeleton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ArrowBack, Download, PictureAsPdf } from '@mui/icons-material'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom'
import { staffEvents } from "../../features/staff/staffSlice";
import { createFile } from "../../features/download/downloadSlice";

const initialState = { teacher: {id: '', codigo: '', nombre: ''}, report: [] };

const StaffEvents = () => {
    const { id } = useParams();
    const { isLoading, isSending } = useSelector(state => state.progress);
    const dispatch = useDispatch();
    const [data, setData] = useState(initialState);
    const { teacher, report } = data;
    const [status, setStatus] = useState('idle');
    const navigate = useNavigate();
    useEffect(() => {
        if(status === 'idle') staffEvents(id, dispatch, setData, setStatus)
    }, [id, dispatch, status])
    let len = report.length;
    const headers = ['Fecha', 'Área', 'Tipo', 'Evento'];
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }}>
            <Typography variant="h5" align="center">{teacher.codigo}</Typography>
            <Typography variant="h6" align="center">{teacher.nombre}</Typography>
            <Button onClick={() => navigate('/administrativos')} startIcon={<ArrowBack />} variant="outlined">Regresar</Button>
            { isLoading ? <Skeleton animation='wave' height={200} /> : len ? (
                <TableContainer sx={{ mt: '1em' }}>
                    <Alert severity="success">Eventos: <b>{len}</b></Alert> <br />
                    <Typography align="center">
                        <LoadingButton 
                            loading={isSending}
                            onClick={() => createFile('report', { id: teacher.id }, dispatch)} 
                            startIcon={<Download />} 
                            endIcon={<PictureAsPdf />} 
                            variant="outlined"
                            color="success"
                            title="Descargar PDF">
                            Reporte
                        </LoadingButton>
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                { headers.map((h, i) => <TableCell key={i}>{h}</TableCell>) }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { report.map(({ fecha, area, tipo, evento }, i) => (
                                <TableRow key={i}>
                                    <TableCell>{fecha}</TableCell>
                                    <TableCell>{area}</TableCell>
                                    <TableCell>{tipo}</TableCell>
                                    <TableCell>{evento}</TableCell>
                                </TableRow>
                            )) }
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : <Alert severity="error">No se econtraron eventos!</Alert> }
        </Container>
    )
}

export default StaffEvents;